import { AnyAction } from 'redux';
import { LOGOUT_SUCCESS, VERIFY_LOGIN_OTP_SUCCESS } from '../types/auth';
import { CREATE_APPLICATION_SUCCESS } from '../types/application';
import { USER_ROLES } from '../../utils/constant';

export type ParamsProps = {
  page: number;
  search: string;
  applicationType: string;
  status: string;
  modeOfHolding: string;
  distributorId: string;
  applicationSentBack: boolean | null;
  amcApproverRequiredApplications: string;
  signed_by_applicants: boolean | null;
};

export const initialState: ParamsProps = {
  page: 1,
  applicationType: '',
  status: '',
  search: '',
  modeOfHolding: '',
  distributorId: '',
  applicationSentBack: null,
  signed_by_applicants: null,
  amcApproverRequiredApplications: '',
};

function paramsReducer(state = initialState, action: AnyAction): Partial<ParamsProps> {
  switch (action.type) {
    case VERIFY_LOGIN_OTP_SUCCESS: {
      return {
        ...state,
        status:
          action.body.role === USER_ROLES.AMCAPPROVER
            ? 'sent_to_amc_approver'
            : action.body.role === USER_ROLES.POAAPPROVER
            ? 'sent_to_poa_approver'
            : '',
        // signed_by_applicants: action.body.role === USER_ROLES.RTAAPPROVER ? true : null,
      };
    }
    case 'GET_PARAMS_DATA':
      return {
        ...state,
        page: action.paramsObj.page,
        applicationType: action.paramsObj.applicationType,
        status: action.paramsObj.status,
        modeOfHolding: action.paramsObj.modeOfHolding,
        distributorId: action.paramsObj.distributorId,
        search: action.paramsObj.search,
        applicationSentBack: action.paramsObj.applicationSentBack,
        signed_by_applicants: action.paramsObj.signed_by_applicants,
        amcApproverRequiredApplications: action.paramsObj.amcApproverRequiredApplications,
      };
    case CREATE_APPLICATION_SUCCESS:
    case LOGOUT_SUCCESS: {
      return { ...initialState };
    }
    default:
      return state;
  }
}

export default paramsReducer;
